import { Dialog } from "@headlessui/react";
import { cn } from "../../../utils/cn";

import { X } from "@pkg/icons"; // TODO - will be replaced be - custom icon package later
import { ReactNode } from "react";

export interface ModalProps {
  children?: ReactNode;
  modalState?: boolean;
  handleCloseModal?: () => void;
  title?: string;
  noCloseButton?: boolean;
  isCenterAligned?: boolean;
  closeOnEsc?: boolean;
  onModalClose?: () => void;
  closeButtonClass?: string;
  theme?: string;
  className?: string;
  overlayBlur?: boolean;
  overlayOpacity?: number;
}

const AppModal = (props: ModalProps) => {
  const {
    modalState,
    handleCloseModal,
    onModalClose = () => {},
    closeButtonClass = "text-black",
    title,
    children,
    noCloseButton = false,
    closeOnEsc = true,
    isCenterAligned = false,
    className,
    theme = "light",
    overlayBlur = false,
    overlayOpacity = 30,
  } = props;

  const onClose = (e: any) => {
    e?.stopPropagation;
    e.stopPropagation();
    handleCloseModal?.();
    onModalClose();
  };
  return (
    <Dialog
      open={modalState}
      onClose={closeOnEsc ? onClose : () => {}}
      className="relative z-50"
    >
      {/* bg overlay */}
      <div
        className={cn("fixed inset-0", overlayBlur && "backdrop-blur-xs")}
        style={{ backgroundColor: `rgba(0, 0, 0, ${overlayOpacity / 100})` }}
        aria-hidden="true"
      />

      <div
        className={cn(
          "fixed top-0 right-0 left-0 max-h-full min-h-screen",
          isCenterAligned ? "h-full" : "",
        )}
      >
        <div
          className={cn("flex min-h-screen items-center justify-center px-5")}
        >
          <Dialog.Panel
            className={cn(
              "relative max-h-[95vh] w-full max-w-md overflow-y-auto rounded-lg bg-white p-6",
              theme === "dark" &&
                "bg-black text-white shadow-[0_0_35px_rgba(255,255,255,0.18)] md:shadow-[0_0_35px_rgba(255,255,255,0.05)]",
              className && className,
            )}
          >
            {title ? (
              <Dialog.Title className="mb-6 flex items-center justify-between font-semibold">
                {title}
              </Dialog.Title>
            ) : null}

            {handleCloseModal && (
              <button
                onClick={onClose}
                className={cn(
                  "absolute top-4 right-4 z-10 w-4 text-lg focus:outline-hidden",
                  noCloseButton && "hidden",
                  closeButtonClass,
                )}
              >
                <X
                  size={20}
                  className="stroke-1 transition-[stroke] duration-300 ease-in hover:stroke-2"
                />
              </button>
            )}

            {children}
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
};

export default AppModal;
